









































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import GenericEdit from '@/core/Generics/GenericEdit';
import AcademicArea from '@/models/academic/academicArea.model';
@Component
export default class AcademicAreaEdit extends GenericEdit<AcademicArea> {
  constructor() {
    super();
    this.controller = 'AcademicArea';
    this.model = new AcademicArea();
  }
}
